module.exports = __webpack_public_path__ + "img/home_seventeen.39aa77ab.png";